module.exports = __webpack_public_path__ + "img/6.17c69d4a.png";